import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import { dragscroll, scroll } from './directive'
import 'element-plus/dist/index.css'

const app = createApp(App)
app.directive("dragscroll", dragscroll)
app.directive("scroll", scroll)
app.use(store).use(router).use(ElementPlus).mount('#app')


